import _isNil from 'lodash/isNil';
import _clamp from 'lodash/clamp';

/**
 * Find the closest option for slider fields based on step, min, and max values
 */
export const findClosestSliderValue = (
	value: number,
	min: number = 1,
	max: number = 20,
	step: number = 1
): number => {
	if (_isNil(value)) return min;

	// Ensure value is within bounds
	const clampedValue = _clamp(value, min, max);

	// Round to nearest step
	const stepsFromMin = Math.round((clampedValue - min) / step);
	return min + (stepsFromMin * step);
};
